export default __webpack_public_path__ + "media/environment_friendly_banner_mobile.3ce0cc19.png";